import React from 'react';

export function StudioXCredit() {
  return (
    <footer className="py-10 text-center text-[11px] text-muted-foreground">
      Utviklet av{' '}
      <a href="https://www.studiox.no" target="_blank" rel="noopener" className="font-medium hover:underline">
        STUDIO X
      </a>
    </footer>
  );
}
